"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uuid;
// Counter being incremented. JS is single-threaded, so it'll Just Work™.
var __counter = 1;

/**
 * Returns a process-wide unique identifier.
 */
function uuid() {
  return "uid-" + __counter++;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-keydown/dist/lib/uuid.js
// module id = 1421
// module chunks = 0